export const REVIEWABLE_APPLICATION_STATUSES = [
  "SUBMITTED",
  "PENDING",
  "IN_REVIEW",
  "PENDING_CERTIFICATION",
  "DRAFT",
];

export const APPLICATION_STATUS_OPTIONS = [
  { value: "ALL", label: "All statuses" },
  { value: "IN_PROCESS", label: "In process" },
  { value: "SUBMITTED", label: "Submitted" },
  { value: "PENDING", label: "Pending" },
  { value: "IN_REVIEW", label: "In review" },
  { value: "PENDING_CERTIFICATION", label: "Pending certification" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "DRAFT", label: "Draft" },
];

export const canReviewApplication = (status) =>
  REVIEWABLE_APPLICATION_STATUSES.includes(status);

function applicationDate(application) {
  return new Date(application.submittedDate || application.createdAt || 0);
}

export function filterApplications(
  applications = [],
  { search = "", status = "ALL", fromDate = "", toDate = "" } = {}
) {
  const query = search.trim().toLowerCase();
  const from = fromDate ? new Date(`${fromDate}T00:00:00`) : null;
  const to = toDate ? new Date(`${toDate}T23:59:59.999`) : null;

  return applications.filter((app) => {
    if (status && status !== "ALL") {
      if (status === "IN_PROCESS") {
        if (!REVIEWABLE_APPLICATION_STATUSES.includes(app.status)) {
          return false;
        }
      } else if (app.status !== status) {
        return false;
      }
    }

    if (query) {
      const haystack = `${app.applicantName || ""} ${app.email || ""} ${
        Array.isArray(app.expertise) ? app.expertise.join(" ") : app.expertise || ""
      }`.toLowerCase();
      if (!haystack.includes(query)) return false;
    }

    if (from || to) {
      const submitted = applicationDate(app);
      if (Number.isNaN(submitted.getTime())) return false;
      if (from && submitted < from) return false;
      if (to && submitted > to) return false;
    }

    return true;
  });
}
